import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import Landing from "./Landing";
import Admin from "./admin/Admin";
import Preloader from "./components/Preloader";

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const timer = setTimeout(() => {

      setLoading(false);

    }, 2500);

    return () => clearTimeout(timer);

  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (

    <Router>

      <Routes>

        {/* 🌐 Landing Pública */}
        <Route
          path="/"
          element={<Landing />}
        />

        {/* 🔐 Panel Administrador */}
        <Route
          path="/admin"
          element={<Admin />}
        />

      </Routes>

    </Router>

  );
}

export default App;